import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";
import Link from "../../utils/Link";

const PlainCard = (item) => {
  const { t } = useTranslation();

  const { ref, parentCategory, blockMode } = item;
  const { title, subtitle, excerpt, slug } =
    item.article || item.category || item;
  const { userLanguage } = useContext(LanguageContext);
  let url = "";

  if (blockMode) {
    url = buildURLForMenuItem(item);
  } else {
    url = `${buildURLForCategory(parentCategory)}/${slug}`;
  }

  return (
    <div className="accounts-row__item filterable-item">
      <Link to={url} className="accounts-row__link">
        <div className="accounts-row__inner">
          <div className="accounts-row__text">
            <div className="accounts-row__title">
              <font>
                <font>{text(title, userLanguage)}</font>
              </font>
            </div>
            <div className="text">
              <p>
                <font>
                  <font>{text(subtitle, userLanguage)}</font>
                </font>
              </p>
              {excerpt && excerpt.text_sq && (
                <p>
                  <font>
                    <font
                      dangerouslySetInnerHTML={{
                        __html: text(excerpt, userLanguage)
                          .split("\n")
                          .join("</br>"),
                      }}
                    ></font>
                  </font>
                </p>
              )}
              <p>
                <span className="button button--i-right">
                  <font>
                    <font>{t("plainCard.buttonText.text")}</font>
                  </font>
                  <i className="i-arrow-circle-right"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default PlainCard;
